import { Dispatch, ExtraArgs, GetState } from '../../types'
import { fetchLoaderHelper } from '../redux/loader/thunksFor'
import { Labels, LABELS_PREFIX, LABELS_RESOURCE_NAME } from './model'
import fetchActionCreatorsFor from '../redux/fetch/actionCreatorsFor'
import { FetchAction } from '../redux/fetch/model'

export type LabelsAction =
  | FetchAction<Labels>

// Basic Actions Creators

export const labelsActionCreators = (origin?: string) => {
  return {
    ...fetchActionCreatorsFor<Labels>(LABELS_RESOURCE_NAME, LABELS_PREFIX, origin)
  }
}

// Thunks

export const fetchLabels = (origin?: string) => (dispatch: Dispatch, getState: GetState, {api}: ExtraArgs) => {
  return fetchLoaderHelper<Labels>(dispatch, labelsActionCreators(origin), async () => {
    return api.ui(getState)
      .fetchLabels(getState().monitoring.auth.profile.organizationId)
      .then(response => {
        return response
      })
  })
}
